window['ThemeSection_Product'] = ({
  product,
  variant,
  featuredMediaID,
  template,
  thumbnailsPosition,
  showThumbnailsOnMobile,
}) => {
  return {
    productRoot: null,
    product: product,
    current_variant: variant,
    featured_media_id: featuredMediaID,
    current_media_id: featuredMediaID,
    loading: false,
    quantity: '1',
    options: [],
    optionHandles: [],
    storeAvailability: null,
    addedToCart: false,
    stickyAddToCartShown: false,
    template: template,
    thumbnailsPosition: thumbnailsPosition,
    showThumbnailsOnMobile: showThumbnailsOnMobile,
    get addToCartText() {
      if (this.current_variant) {
        if (this.loading) {
          return window.theme.strings.loading;
        }
        if (!this.loading && this.current_variant.available) {
          if (this.template === 'product.preorder') {
            return window.theme.strings.preOrder;
          } else {
            return window.theme.strings.addToCart;
          }
        }
        if (!this.loading && !this.current_variant.available) {
          return window.theme.strings.soldOut;
        }
      } else {
        return window.theme.strings.unavailable;
      }
    },
    get currentVariantId() {
      if (this.current_variant) {
        return this.current_variant.id;
      } else {
        return null;
      }
    },
    get currentVariantAvailabilityClosestLocation() {
      // this is on a lag to the actual current variant so that we can display an intermediary state while the fetch request is happening
      if (!Alpine.store('availability')) return null;

      const id = this.currentVariantId;
      const storeData = Alpine.store('availability').availability[id];
      if (storeData) {
        return storeData.closest_location;
      } else {
        return null;
      }
    },
    get currentVariantAvailable() {
      if (this.current_variant) {
        return this.current_variant.available;
      } else {
        return null;
      }
    },
    get currentVariantTitle() {
      if (this.current_variant && this.current_variant.title) {
        if (!this.current_variant.title.includes('Default')) {
          return this.current_variant.title;
        }
      }
      return '';
    },
    get current_price() {
      return this.current_variant.price;
    },
    get isUsingSlideshowToDisplayMedia() {
      const splideEl = this.productRoot.querySelector('.splide--product');

      if (window.Splide && this.productRoot && splideEl) {
        if (
          window.slideshows &&
          window.slideshows[`${splideEl.id}`] &&
          !window.slideshows[`${splideEl.id}`].state.is(
            window.Splide.STATES.DESTROYED
          )
        ) {
          return true;
        }
      }

      return false;
    },
    formatMoney(price) {
      return formatMoney(price, theme.moneyFormat);
    },
    init() {
      // Set a product root for nested components
      // to use instead of $root (which refers to their root)
      this.productRoot = this.$root;

      if (this.$refs.productForm) {
        this.$refs.productForm.addEventListener(
          'submit',
          this.submitForm.bind(this)
        );
      }

      this.getOptions();
      this.getAddToCartButtonHeight();

      this.$watch('current_media_id', (value, oldValue) => {
        if (showThumbnailsOnMobile) {
          this.$root.dispatchEvent(
            new CustomEvent('shapes:product:mediachange', {
              bubbles: true,
              detail: {
                media_id: this.current_media_id,
                slideshow_id:
                  this.productRoot.querySelector('.splide--product')?.id,
              },
            })
          );
        }
        if (this.isUsingSlideshowToDisplayMedia) return;
        this.$root
          .querySelector(`[data-product-single-media-wrapper="${oldValue}"]`)
          .dispatchEvent(new CustomEvent('mediaHidden'));
        this.$root
          .querySelector(`[data-product-single-media-wrapper="${value}"]`)
          .dispatchEvent(new CustomEvent('mediaVisible'));
      });

      this.updateStoreAvailability(this.current_variant);
    },
    getAddToCartButtonHeight() {
      window.onload = function () {
        const height = document.querySelector('.add-to-cart-btn').offsetHeight;
        document.documentElement.style.setProperty(
          '--payment-button-height',
          `${height}px`
        );
      };
    },
    updateStoreAvailability(variant) {
      if (!this.$refs.storeAvailabilityContainer) return;
      this.storeAvailability =
        this.storeAvailability ||
        new StoreAvailability(this.$refs.storeAvailabilityContainer);

      if (this.storeAvailability && variant) {
        this.storeAvailability.fetchContent(variant);
      }
    },
    optionChange() {
      this.getOptions();

      const matchedVariant = ShopifyProduct.getVariantFromOptionArray(
        this.product,
        this.options
      );

      this.current_variant = matchedVariant;

      if (this.current_variant) {
        variantLiveRegion(this.current_variant);
        this.updateStoreAvailability(this.current_variant);

        if (this.current_variant.featured_media) {
          this.current_media_id = this.current_variant.featured_media.id;
        }

        var ingredients = "";
        var src = "";
        var smallsrc = "";
        var item = "";
        var bannerImage = "";
        var borderColor = "";
        var backgroundColor = "";
        var vectorImage = "";
        var addCartBtn = "";
        var borderCartBtn = "";
       var newVariantDescription = "";
        
          
        var hElement = document.querySelector('.simple-ingredients h1');
        var ingredientsElement = document.querySelector('.simple-ingredients p');
        var imageElement = document.querySelector('.ingredients_images_area img');
        var smallimageElement = document.querySelector('.smallingredients_smallimages_area img');
        var bannerProductImage = document.querySelector('#banner-product-image');
        var productMediaContainer = document.querySelector('.product-media .col-span-6');
        var ingredientsContainer = document.querySelector('.simple-ingredients');
        var vectorImageContainer = document.querySelector('.vector_image');
        var addCartContainer = document.querySelector('.push-btn-add-to-cart');
         var newDescription = document.querySelector('.new-description p');
        // var borderCartContainer = document.querySelector('.push-btn-add-to-cart');
        if(this.current_variant.title === "Banana Bread") {
          item="6 Simple ingredients";
          ingredients = "Chickpeas, Diced Bananas,\n Coconut Sugar, Natural Flavors,\n Cinnamon, Sea Salt";
          src = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/Banana_Bread_Label.png?v=1713526493";
          smallsrc = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/Apple_-_Mobile.png?v=1721715152";
          bannerImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/yellow.png?v=1715236267";
          borderColor = "1px solid #f8c078";
          borderCartBtn = "1px solid #f8c078";
          backgroundColor = "#f8c078";
          addCartBtn = "#f8c078";
          vectorImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/vector-yellow.png?v=1715253222";
          newVariantDescription = "Enjoy the warm, nostalgic flavor of banana bread. This hearty breakfast provides 10g of protein, 190 calories, and 3g of sugar.";
        } else if (this.current_variant.title === "Apple Pie") {
          item="6 Simple ingredients";
          ingredients = "Chickpeas, Diced Apples,\n Coconut Sugar, Cinnamon,\n Natural Flavors, Sea Salt";
          src = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/Apple_Pie_Label.png?v=1713526492";
          smallsrc = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/Apple_-_Mobile.png?v=1721715152";
          bannerImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/pink.png?v=1715236267";
          borderColor = "1px solid #ff8b7c";
          borderCartBtn = "1px solid #ff8b7c";
          backgroundColor = "#ff8b7c";
          addCartBtn = "#ff8b7c";
          vectorImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/pink_18c5d3d6-454a-4ea8-a7e7-3d8fea48552d.png?v=1715352464";
          newVariantDescription = "Delicious and comforting with the taste of homemade apple pie. Each serving packs 10g of protein, 190 calories, and 3g of sugar.";
        } else if (this.current_variant.title === "Maple Syrup") {
          item="4 Simple ingredients";
          ingredients = "Chickpeas, Dates,\n Natural Maple Flavor, Sea Salt";
          src = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/Maple_Flavor_-_Nutrition_Label-6.png?v=1713526492";
          smallsrc = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/Maple_-_mobile.png?v=1721714108";
          bannerImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/brown.png?v=1715236267";
          borderColor = "1px solid #cc8f75";
          borderCartBtn = "1px solid #cc8f75";
          backgroundColor = "#cc8f75";
          addCartBtn = "#cc8f75";
          vectorImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/Vector_1_0174eacd-1f52-4231-b21f-be3a858b0668.png?v=1715346928";
          newVariantDescription = "Indulge in the rich, comforting taste of maple syrup. With 10g of protein, 190 calories, and no added sugar per serving, it's a healthy start to your day.";
        } else if (this.current_variant.title === "Original") { 
          item="1 Simple ingredient";
          ingredients = "Chickpeas";
          src = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/original_-_Nutrition_Label-5.png?v=1713526455";
          smallsrc = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/original_-_mobile.png?v=1721714224123";
          bannerImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/blue.png?v=1715236267";
          borderColor = "1px solid #7fcfca";
          borderCartBtn = "1px solid #7fcfca";
          backgroundColor = "#7fcfca";
          addCartBtn = "#7fcfca";
          vectorImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/vector-blue.png?v=1715253222";
          newVariantDescription = "Versatile and nutritious, perfect for sweet or savory dishes, or in your favorite baking recipes. A healthy base for any meal, packed with 11g of protein, 190 calories, and no added sugar per serving.";
        } else { 
          item="";
          ingredients = "";
          src = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/variety_pack_-_desktop.png?v=1721713262";
          smallsrc = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/Variety_pack_-_mobile.png?v=1721713968";
          bannerImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/brown.png?v=1715236267";
          borderColor = "1px solid #e3a198";
          borderCartBtn = "1px solid #e3a198";
          backgroundColor = "#e3a198";
          addCartBtn = "#e3a198";
          vectorImage = "https://cdn.shopify.com/s/files/1/0698/4568/0423/files/vector-brown.png?v=1715253222";
          newVariantDescription = "Experience the full range of delicious flavors: Apple Pie, Banana Bread, Maple Syrup, and Original. Each pack offers a nutritious, protein-rich breakfast option to suit any craving.";
        }
        if (ingredientsElement) {
          ingredientsElement.innerText = ingredients;
          imageElement.src = src;
          smallimageElement.src = smallsrc;
          hElement.innerText=item;
          bannerProductImage.src = bannerImage;
          productMediaContainer.style.border = borderColor;
          // borderCartContainer.style.border = borderCartBtn;
          ingredientsContainer.style.backgroundColor = backgroundColor;
          addCartContainer.style.backgroundColor = addCartBtn;
          vectorImageContainer.src = vectorImage;
          newDescription.innerText = newVariantDescription;
        }
        const url = ShopifyProductForm.getUrlWithVariant(
          window.location.href,
          this.current_variant.id
        );

        window.history.replaceState({ path: url }, '', url);
        this.$refs.singleVariantSelector.dispatchEvent(
          new Event('change', { bubbles: true })
        );
        this.$root.dispatchEvent(
          new CustomEvent('shapes:product:variantchange', {
            bubbles: true,
            detail: { variant: this.current_variant },
          })
        );
      }
    },
    getOptions() {
      this.options = [];
      this.optionHandles = [];

      let selectors = this.$root.querySelectorAll(
        '[data-single-option-selector]'
      );

      selectors.forEach((selector) => {
        if (selector.nodeName === 'SELECT') {
          const value = selector.value;
          this.options.push(value);
          this.optionHandles.push(
            selector.options[selector.selectedIndex].dataset.handle
          );
        } else {
          if (selector.checked) {
            console;
            const value = selector.value;
            this.options.push(value);
            this.optionHandles.push(selector.dataset.handle);
          }
        }
      });
    },
    changeMedia(direction) {
      this.$root.dispatchEvent(
        new CustomEvent('shapes:product:arrow-change', {
          bubbles: true,
          detail: { direction: direction },
        })
      );
      if (this.thumbnailsPosition == 'under') {
        const currentThumbnail = this.$root.querySelector(
          '.product-thumbnail-list-item--active'
        );
        const nextElement =
          direction == 'prev'
            ? currentThumbnail.previousElementSibling
            : currentThumbnail.nextElementSibling;
        if (nextElement !== null) {
          nextElement.querySelector('.media-thumbnail').click();
        }
      }
    },
    submitForm(evt) {
      evt.preventDefault();
      this.loading = true;

      liveRegion(window.theme.strings.loading);

      const formData = new FormData(this.$refs.productForm);

      let modalCart = theme.settings.cart_type === 'modal';

      const config = fetchConfigDefaults('javascript');

      if (modalCart) {
        formData.append('sections', 'cart-items,cart-footer,cart-item-count');
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.loading = false;
            throw data.description;
          }
          this.loading = false;
          this.addedToCart = true;

          if (modalCart) {
            document.body.dispatchEvent(
              new CustomEvent('shapes:modalcart:afteradditem', {
                bubbles: true,
                detail: { response: data },
              })
            );
          }

          if (!document.querySelector('[data-show-on-add="true"]')) {
            if (this.$refs.added)
              this.$nextTick(() => this.$refs.added.focus());
          }
        })
        .catch((error) => {
          if (typeof error === 'string') {
            alert(error);
          } else {
            error.json().then((a) => {
              this.loading = false;
              alert(a.description);
            });
          }
        });
    },
    openZoom(id) {
      const imageZoomDataEl = this.productRoot.querySelector(
        '[data-photoswipe-images]'
      );

      if (!imageZoomDataEl) return;

      const imageZoomData = JSON.parse(imageZoomDataEl.innerHTML);

      const imageMediaIDsArray = Object.keys(imageZoomData);

      const index = imageMediaIDsArray.indexOf(id);

      this.$refs.photoSwipeComponent.dispatchEvent(
        new CustomEvent('shapes:photoswipe:open', {
          detail: {
            index: index,
          },
        })
      );
    },
  };
};

window['productThumbnails'] = () => {
  return {
    firstVisible: true,
    lastVisible: false,
    mounted() {
      const firstThumbnail = this.$refs.firstThumbnail;
      const lastThumbnail = this.$refs.lastThumbnail;
      const options = {
        root: this.$root.querySelector('.splide__track'),
        rootMargin: '0px',
        threshold: 1.0,
      };
      const firstThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.firstVisible = true;
          } else {
            this.firstVisible = false;
          }
        },
        options
      );
      const lastThumbnailObserver = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.lastVisible = true;
          } else {
            this.lastVisible = false;
          }
        },
        options
      );
      firstThumbnailObserver.observe(firstThumbnail);
      lastThumbnailObserver.observe(lastThumbnail);
    },
  };
};
